import axiosInstance from "./interceptor";

export const getPaymentSchedule = async (queryId) => {
  try {
    const response = await axiosInstance.get(`/payment-schedule/${queryId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const upsertPaymentSchedule = async (data) => {
  try {
    const response = await axiosInstance.post(`/payment-schedule`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateInstallmentStatus = async (scheduleId, installmentId, data) => {
  try {
    const response = await axiosInstance.patch(`/payment-schedule/${scheduleId}/installment/${installmentId}`, data);
    return response.data;
  } catch (error) {
    throw error;
  }
};
